import {css} from 'lit';
export const styles = css`.wrapper {
  --width: var(--file-icon-width, 30px);
  --height: var(--file-icon-height, calc(var(--width) * 1.33));
  --color: var(--file-icon-text-color, var(--contrast-light));
  --font-size: var(--file-icon-font-size, var(--font-size-sm));
  --parent-background: var(--file-icon-parent-background, var(--body-bg));

  position: relative;
  width: var(--width);
  height: var(--height);
  color: var(--color);
  font-weight: 700;
  font-size: var(--font-size);
  background-color: #636a79;
  border-radius: 4px;
}

  .wrapper.image {
    background-color: #0071a4;
  }

  .wrapper.audio {
    background-color: #b25000;
  }

  .wrapper.doc {
    background-color: #276dd6;
  }

  .wrapper.presentation {
    background-color: #d70015;
  }

  .wrapper.sheet {
    background-color: #248a3d;
  }

.folded-corner {
  position: absolute;
  top: 0;
  right: 0;
  width: calc(var(--width) / 2.5);
  height: calc(var(--width) / 2.5);
  border-bottom-left-radius: 4px;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 50%) 0%,
    rgba(255, 255, 255, 50%) 50%,
    var(--parent-background) 51%,
    var(--parent-background) 100%
  );
}

.extension {
  position: absolute;
  bottom: 4px;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
}

.extension.len-4 {
    font-size: 0.8em;
  }

.extension.len-5 {
    font-size: 0.7em;
  }
`;
export default styles;
